import React from "react";
import { ExpressionView } from "../ExpressionView";

import { expressionStoryData } from "../Testing/ExpressionData";
import { ExpressionConfiguration } from "../../rule-engine-core/Expressions/ExpressionConfiguration";
import { getDivideSimpleRule } from "../Testing/MathData";
import { MaxExpression } from "../../rule-engine-core/Expressions/Expressions/Math/MaxExpression";
import { MultiplyExpression } from "../../rule-engine-core/Expressions/Expressions/Math/MultiplyExpression";
import { EqualExpression } from "../../rule-engine-core/Expressions/Expressions/Math/EqualExpression";
import { ModExpression } from "../../rule-engine-core/Expressions/Expressions/Math/ModExpression";
import { RoundExpression } from "../../rule-engine-core/Expressions/Expressions/Math/RoundExpression";
import { AverageExpression } from "../../rule-engine-core/Expressions/Expressions/Math/AverageExpression";
import { NotEqualExpression } from "../../rule-engine-core/Expressions/Expressions/Math/NotEqualExpression";
import { RandomExpression } from "../../rule-engine-core/Expressions/Expressions/Math/RandomExpression";
import { MinExpression } from "../../rule-engine-core/Expressions/Expressions/Math/MinExpression";
import { AddExpression } from "../../rule-engine-core/Expressions/Expressions/Math/AddExpression";
import { SubstractExpression } from "../../rule-engine-core/Expressions/Expressions/Math/SubstractExpression";
import { AsCurrencyExpression } from "../../rule-engine-core/Expressions/Expressions/Math/AsCurrencyExpression";
import { AbsoluteExpression } from "../../rule-engine-core/Expressions/Expressions/Math/AbsoluteExpression";
import { SumExpression } from "../../rule-engine-core/Expressions/Expressions/Math/SumExpression";
import { AsPercentageExpression } from "../../rule-engine-core/Expressions/Expressions/Math/AsPercentageExpression";
import { StoryNode } from "../../CommonUI/StoryBook/StoryData";

export const ExpressionViewMathStories = [
    new StoryNode(
        () => {
            let expression = new AbsoluteExpression();
            expression.value1.value = -1;
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Math",
        "Absolute",
    ),

    new StoryNode(
        () => {
            let expression = new AddExpression();
            expression.value1.value = -1;
            expression.value2.value = 10;
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Math",
        "Add",
    ),
    new StoryNode(
        () => {
            let expression = new AsCurrencyExpression();
            expression.value1.value = -1;
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Math",
        "As Currency",
    ),
    new StoryNode(
        () => {
            let expression = new AsPercentageExpression();
            expression.value1.value = -1;
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Math",
        "As Percentage",
    ),
    new StoryNode(
        () => {
            let expression = new AverageExpression();
            expression.value1.variableName = "numberList";
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Math",
        "Average",
    ),
    new StoryNode(
        () => {
            let exp = getDivideSimpleRule();
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Math",
        "Divide",
    ),
    new StoryNode(
        () => {
            let expression = new EqualExpression();
            expression.value1.variableName = "value1";
            expression.value2.variableName = "value2";
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Math",
        "Equal",
    ),
    new StoryNode(
        () => {
            let expression = new MaxExpression();
            expression.value1.variableName = "numberList";
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Math",
        "Max",
    ),
    new StoryNode(
        () => {
            let expression = new MinExpression();
            expression.value1.variableName = "numberList";
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Math",
        "Min",
    ),
    new StoryNode(
        () => {
            let expression = new ModExpression();
            expression.value1.variableName = "numberList";
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Math",
        "Mod",
    ),
    new StoryNode(
        () => {
            let expression = new MultiplyExpression();
            expression.value1.variableName = "value1";
            expression.value2.variableName = "value2";
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Math",
        "Multipy",
    ),
    new StoryNode(
        () => {
            let expression = new NotEqualExpression();
            expression.value1.variableName = "value1";
            expression.value2.variableName = "value2";
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Math",
        "Not Equal",
    ),
    new StoryNode(
        () => {
            let expression = new RandomExpression();
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Math",
        "Random",
    ),
    new StoryNode(
        () => {
            let expression = new RoundExpression();
            expression.value1.variableName = "value1";
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Math",
        "Round",
    ),
    new StoryNode(
        () => {
            let expression = new SubstractExpression();
            expression.value1.variableName = "value1";
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Math",
        "Subtract",
    ),
    new StoryNode(
        () => {
            let expression = new SumExpression();
            expression.value1.variableName = "numberList";
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Math",
        "Sum",
    ),
];
